import Viewer from "@/helpers/viewer.js"
export default {
  methods: {
    showVuerPlaylist(e,refImage,centerImage,index) {
      
      let viewerRef = this.$refs[refImage]
      if (typeof index === 'number') viewerRef = this.$refs[refImage][index] 
      
      let viewer = new Viewer(viewerRef, {
        toolbar: false,
        tooltip: true,
        navbar: false,
        zoomable: true,
        title: false,
        scalable: false,
        fullscreen: false,
        keyboard: false,
        hide: function(){
          viewer.destroy()
        }
      });

      viewer.showOverride(true, {
        originalEvent : (centerImage) ? null : e
      });
    },
    showVuerSingle(e,refImage,centerImage) {
      let viewerRef = this.$refs[refImage][0] ? this.$refs[refImage][0] : this.$refs[refImage]
      
      let viewer = new Viewer(viewerRef, {
        toolbar: false,
        tooltip: true,
        navbar: false,
        zoomable: true,
        title: false,
        scalable: false,
        fullscreen: false,
        keyboard: false,
        hide: function(){
          viewer.destroy()
        }
      });

      viewer.showOverride(true, {
        originalEvent : (centerImage) ? null : e
      });
    },
    showVuerSingleElement(e,img,centerImage) {
      let viewerRef = img
      
      let viewer = new Viewer(viewerRef, {
        toolbar: false,
        tooltip: true,
        navbar: false,
        zoomable: true,
        title: false,
        scalable: false,
        fullscreen: false,
        keyboard: false,
        hide: function(){
          viewer.destroy()
        }
      });

      viewer.showOverride(true, {
        originalEvent : (centerImage) ? null : e
      });
    },
    showVuerNormal(e,refImage) {
      let viewerRef = this.$refs[refImage]
      
      let viewer = new Viewer(viewerRef, {
        toolbar: false,
        tooltip: true,
        navbar: false,
        zoomable: true,
        title: false,
        scalable: false,
        fullscreen: false,
        keyboard: false,
        hide: function(){
          viewer.destroy()
        }
      });

      viewer.show(true);
    }
  }
}